
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.75 12.74V32.2a5.71 5.71 0 005.58 5.8h17.34a5.71 5.71 0 005.58-5.8V12.74z","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"d":"M33.63 12.74h5s.62 6.49-2.48 6.49H34.4M6.37 12.74h-5S.7 19.23 3.8 19.23h1.94M16.3 6.1V2h7.4v4.1M21 33.51h5.41A3.43 3.43 0 0029.79 30v-5.62M6.41 12.93A17.5 17.5 0 0134 12.67","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}})])
          )
        }
      }
    